import React, { useContext, useState, useEffect } from "react";
import "./Sidebar.css";
import "../../Ant.css";
// import { AuthContext } from "../../Api/authReq";
import { Menu, Modal, Button } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Colors from "../../Helper/Colors";
import FormatHelper from "../../Helper/FormatHelper";
import { techappContext } from "../../Api/techappReq";
// import Images
import avatarImage from "../../assets/images/techapp/avatar-min.png";
import ordersWhite from "../../assets/images/techapp/orders-white.svg";
import commentWhite from "../../assets/images/techapp/comment-white.svg";
import profileWhite from "../../assets/images/techapp/user-white.svg";
import logoutWhite from "../../assets/images/techapp/logout-white.svg";
import { TfiStatsUp } from "react-icons/tfi";
import { FaStar } from "react-icons/fa";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const profileData = useSelector((state) => state.TechAppReducer.profileData);

  const [sidebarMenuSelectedKeys, setSidebarMenuSelectedKeys] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  // const { fcmToken } = useContext(AuthContext);

  const { handleLogout, getBadges } = useContext(techappContext);

  const confirmLogout = () => {
    setIsOpen(false);
    handleLogout();
  };

  const handleSelectedMenuItem = () => {
    switch (location.pathname) {
      // state _ 1
      case "/techapp":
        setSidebarMenuSelectedKeys(["1"]);
        break;
      case "/techapp/define-cost":
        setSidebarMenuSelectedKeys(["1"]);
        break;
      case "/techapp/view-order":
        setSidebarMenuSelectedKeys(["1"]);
        break;
      case "/techapp/complaint":
        setSidebarMenuSelectedKeys(["1"]);
        break;
      // state _ 2
      case "/techapp/stats":
        setSidebarMenuSelectedKeys(["2"]);
        break;
      // state _ 3
      case "/techapp/tickets":
        setSidebarMenuSelectedKeys(["3"]);
        break;
      case "/techapp/view-ticket":
        setSidebarMenuSelectedKeys(["3"]);
        break;
      case "/techapp/create-ticket":
        setSidebarMenuSelectedKeys(["3"]);
        break;
      // state _ 4
      case "/techapp/profile":
        setSidebarMenuSelectedKeys(["4"]);
        break;
      case "/techapp/bug-report":
        setSidebarMenuSelectedKeys(["4"]);
        break;
      // state _ 5
      case "/techapp/survey":
        setSidebarMenuSelectedKeys(["5"]);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    handleSelectedMenuItem();
  }, [location.pathname]);

  return (
    <div className="tech-app-sidebar">
      <div className="tech-app-sidebar-avatar">
        <div className="tech-app-sidebar-avatar-wrapper">
          {profileData.avatar === "" || profileData.avatar === null ? (
            <img
              style={{ borderRadius: "50%" }}
              src={avatarImage}
              alt="user avatar"
            />
          ) : (
            <img
              style={{ borderRadius: "50%" }}
              src={profileData.avatar}
              alt="user avatar"
            />
          )}
        </div>
      </div>
      <div className="tech-app-sidebar-username">
        {profileData.first_name} {profileData.last_name}
      </div>
      <div className="tech-app-sidebar-charge">
        موجودی حساب :{" "}
        <span
          style={
            profileData > 0
              ? { color: Colors.success }
              : { color: Colors.danger }
          }
        >
          {FormatHelper.toPersianString(
            Math.abs(profileData.balance).toLocaleString()
          )}
        </span>{" "}
        تومان
      </div>
      <Menu
        defaultSelectedKeys={["1"]}
        selectedKeys={sidebarMenuSelectedKeys}
        style={{ backgroundColor: Colors.royalBlue, width: "100%" }}
      >
        {/* orders */}
        <Menu.Item
          onClick={() => navigate("/techapp")}
          key="1"
          style={{ fontSize: "18px", marginBottom: "15px", color: "white" }}
        >
          <img
            style={{ marginLeft: "10px", width: "17px" }}
            src={ordersWhite}
            alt="orders"
          />
          سفارشات
        </Menu.Item>
        {/* survey */}
        <Menu.Item
          onClick={() => navigate("/techapp/survey")}
          key="5"
          style={{
            fontSize: "18px",
            marginBottom: "15px",
            color: "white",
          }}
        >
          <FaStar fontSize={17} style={{ marginTop: 2, marginLeft: 8 }} />
          <span style={{ marginBottom: 2 }}>امتیازات</span>
        </Menu.Item>
        {/* chat */}
        <Menu.Item
          onClick={() => navigate("/techapp/tickets")}
          key="3"
          style={{ fontSize: "18px", marginBottom: "15px", color: "white" }}
          id="sidebar_chat_menu"
        >
          <img
            style={{ marginLeft: "10px", width: "17px" }}
            src={commentWhite}
            alt="ticket"
          />
          گفتگو
          {getBadges && (
            <div className="techapp-show-unread-messages-count">
              {FormatHelper.toPersianString(
                getBadges.training +
                  getBadges.public +
                  getBadges.private +
                  getBadges.ticket
              )}
            </div>
          )}
        </Menu.Item>
        {/* stats */}
        <Menu.Item
          onClick={() => navigate("/techapp/stats")}
          key="2"
          style={{ fontSize: "18px", marginBottom: "15px", color: "white" }}
        >
          <TfiStatsUp style={{ marginLeft: 10 }} />
          عملکرد من
        </Menu.Item>
        {/* profile */}
        <Menu.Item
          onClick={() => navigate("/techapp/profile")}
          key="4"
          style={{ fontSize: "18px", marginBottom: "15px", color: "white" }}
          id="sidebar_profile_menu"
        >
          <img
            style={{ marginLeft: "10px", width: "17px" }}
            src={profileWhite}
            alt="profile"
          />
          پروفایل
        </Menu.Item>
        {/* exit */}
        <Menu.Item
          onClick={() => setIsOpen(true)}
          key="6"
          style={{ fontSize: "18px", color: "white" }}
        >
          <img
            style={{ marginLeft: "10px", width: "17px" }}
            src={logoutWhite}
            alt="log out"
          />
          خروج
        </Menu.Item>
      </Menu>
      <Modal
        ariaHideApp={false}
        open={isOpen}
        onOk={confirmLogout}
        onCancel={() => setIsOpen(false)}
        className="techapp-action-cancel-order"
        style={{ borderRadius: "6px", textAlign: "center" }}
        title={"آیا مایل به خروج هستید؟"}
        footer={[
          <>
            <Button
              onClick={() => setIsOpen(false)}
              className="tech-app-reset-data-btns btn-text-black"
              style={{
                backgroundColor: "rgba(199, 199, 199, 0.322)",
                color: "black",
              }}
            >
              خیر
            </Button>
            <Button
              onClick={confirmLogout}
              className="tech-app-reset-data-btns btn-text-white"
              style={{ backgroundColor: Colors.danger, color: "white" }}
            >
              بلی
            </Button>
          </>,
        ]}
      ></Modal>
    </div>
  );
};
export default Sidebar;
